import { IsNotEmpty, IsOptional, IsString } from 'class-validator'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'

export class CreateEstablishmentRoleDto {
  @ApiProperty({
    type: 'string',
    description: "Code du rôle d'établissement",
    example: 'PRINCIPAL',
  })
  @IsNotEmpty()
  @IsString()
  code!: string

  @ApiProperty({
    type: 'string',
    description: "Nom du rôle d'établissement",
    example: 'Principal',
  })
  @IsNotEmpty()
  @IsString()
  name!: string

  @ApiPropertyOptional({ type: 'string', description: 'Description' })
  @IsOptional()
  @IsString()
  description?: string

  @ApiPropertyOptional({ type: 'string', description: 'Permissions (JSON)' })
  @IsOptional()
  @IsString()
  permissions?: string
}
